import React from "react";
import { useSettings } from "@/context/SettingsContext";
import { usePageContent } from "@/hooks/usePageContent";
import { Instagram, MessageCircle } from "lucide-react";

const ContactPage = () => {
  const { settings } = useSettings();
  const c = usePageContent("contact");

  const wa = (settings?.whatsapp_number || "").replace(/[^\d]/g, "");
  const waLink = `https://wa.me/${wa}?text=${encodeURIComponent(
    "¡Hola AQ Watches! Me gustaría conocer más sobre sus piezas personalizadas."
  )}`;
  const ig = settings?.instagram_url || "https://instagram.com/aqwatchvault";

  return (
    <div data-testid="contact-page" className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-14 py-24 lg:py-32">
      <div className="text-center mb-16 lg:mb-20">
        <p className="overline mb-5">{c.overline || "Hablemos"}</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-6">
          {c.title || "Diseñemos tu reloj personalizado."}
        </h1>
        <p className="text-[var(--aq-muted)] leading-relaxed max-w-xl mx-auto">
          {c.subtitle || "AQ Watches trabaja directamente con cada cliente por WhatsApp."}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        <a
          href={waLink}
          target="_blank"
          rel="noreferrer"
          data-testid="contact-whatsapp"
          className="group relative border border-[var(--aq-border)] hover:border-black bg-white p-10 lg:p-12 transition-colors block"
        >
          <div className="flex items-start justify-between mb-8">
            <div className="w-14 h-14 rounded-full bg-[var(--aq-success)] text-white flex items-center justify-center group-hover:scale-105 transition-transform">
              <MessageCircle size={26} />
            </div>
            <span className="overline">Recomendado</span>
          </div>
          <h2 className="font-display text-2xl sm:text-3xl mb-3">{c.whatsapp_title || "Chatear por WhatsApp"}</h2>
          <p className="text-sm text-[var(--aq-muted)] mb-8 leading-relaxed">
            {c.whatsapp_text || "Directo, rápido y privado. La mayoría de respuestas llegan en pocas horas."}
          </p>
          <span className="text-[11px] uppercase tracking-[0.28em] border-b border-black pb-1">
            Abrir WhatsApp →
          </span>
          {settings?.whatsapp_number && (
            <p className="mt-6 text-sm text-[var(--aq-ink)]">{settings.whatsapp_number}</p>
          )}
        </a>

        <a
          href={ig}
          target="_blank"
          rel="noreferrer"
          data-testid="contact-instagram"
          className="group relative border border-[var(--aq-border)] hover:border-black bg-white p-10 lg:p-12 transition-colors block"
        >
          <div className="flex items-start justify-between mb-8">
            <div className="w-14 h-14 rounded-full bg-black text-white flex items-center justify-center group-hover:scale-105 transition-transform">
              <Instagram size={24} />
            </div>
            <span className="overline">Síguenos</span>
          </div>
          <h2 className="font-display text-2xl sm:text-3xl mb-3">{c.instagram_title || "Instagram"}</h2>
          <p className="text-sm text-[var(--aq-muted)] mb-8 leading-relaxed">
            {c.instagram_text || "Mira piezas anteriores, procesos detrás de escena y nuevos lanzamientos."}
          </p>
          <span className="text-[11px] uppercase tracking-[0.28em] border-b border-black pb-1">
            Abrir Instagram →
          </span>
          {settings?.instagram_handle && (
            <p className="mt-6 text-sm text-[var(--aq-ink)]">{settings.instagram_handle}</p>
          )}
        </a>
      </div>

      <div className="mt-20 text-center">
        <p className="text-[11px] uppercase tracking-[0.32em] text-[var(--aq-muted)]">
          {c.footer_note || "No usamos correo electrónico ni formularios — WhatsApp es la forma más rápida de contactar al atelier."}
        </p>
      </div>
    </div>
  );
};

export default ContactPage;
